import React, { useEffect } from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  HasLoadedFromCookieSelector,
  InitialDataSelector,
  ShowResetButtonsSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { setHasFinishedSelection, setShowFitAssistant, setShowResetButtons } from '../../Slices/FitAssistantSlice.ts';
import { trackNoFit, trackOpenEmpty, trackView } from '../../Analytics/Adobe.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import FitAssistantVariation from '../../Enums/FitAssistantVariation.ts';

import './NoFit.less';
import { CloseType } from '../../Types/Tracking.ts';

const NoFit = () => {
  const dispatch = useAppDispatch();
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const showResetButtons = useAppSelector(ShowResetButtonsSelector);
  const translations = useAppSelector(TranslationsSelector);
  const hasLoadedFromCookie = useAppSelector(HasLoadedFromCookieSelector);

  useEffect(() => {
    trackView(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      hasLoadedFromCookie
    );

    dispatch(setHasFinishedSelection(true));
  }, []);

  const trackNoFitClick = (closeType: CloseType, clickLink?: string) => {
    trackNoFit(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      closeType,
      clickLink
    );
  };

  const onClickPrimary = () => {
    trackNoFitClick('Close');
    dispatch(setShowFitAssistant(false));
    dispatch(setShowResetButtons(true));
  };

  const onClickSecondary = () => {
    trackNoFitClick('Reset');
    trackOpenEmpty(initialData.FitAssistantVariation, initialData.IsYearFirst, [], initialData.Steps[0].Parameter);
    dispatch(resetFitAssistant(true));
  };

  const onClickContent = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const linkElement = (e.target as HTMLElement).closest('a') as HTMLAnchorElement;
    if (linkElement) {
      trackNoFitClick('Read more', linkElement.href);
      window.location.href = linkElement.href;
    }
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
        {initialData.FitAssistantVariation === FitAssistantVariation.RooftopTents &&
          currentStepContent?.ResultContent && (
            <div className="result-content mt-11">
              <h5 className="mb-4">{translations.readMore}</h5>
              <div className="items">
                {currentStepContent?.ResultContent?.map((result, index) => (
                  <div key={index}>
                    <a href={result.Link} target="_blank" rel="noopener noreferrer" onClick={onClickContent}>
                      <img src={result.ImageUrl} alt={result.ImageAlt} className="mb-4" />
                      {result.LinkText}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.close} onClick={onClickPrimary} />
        <SecondaryButton visible={showResetButtons} text={translations.reset} onClick={onClickSecondary} />
      </Buttons>
    </>
  );
};

export default NoFit;
